import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select';
import ApiService from '../../../../services/apiService';
import ApiService2 from '../../../../../INVENTORY/services/apiService';
import ImageUpload from './imagUpload';
import { ReactComponent as Delete } from '../../../../assets/images/svgIcons/Delete.svg';
import { ReactComponent as AddOn } from '../../../../assets/images/svgIcons/addon.svg';
import { connect } from 'react-redux';
import { getUserId, getUserName } from '../../../../../Redux/selecters';
import { useSelector } from 'react-redux';
import moment from 'moment';

const UpdateMenu = ({ Currency }) => {
  let navigate = useNavigate();
  const location = useLocation();
  const { state } = useLocation();
  const val = state?.item;
  console.log(val);
  const UserId = useSelector(getUserId);

  // Form data state - SAME structure as your design but mapped to UPDATE_ITEM_MASTER API
  const [formData, setFormData] = useState({
    record_Id: '',
    itemName: '',
    brand: '',
    description: '',
    retailPrice: '',
    wholesalePrice: '',
    costPrice: '',
    taxRate: '',
    category: '',
    subcategory: '',
    barcode: '',
    supplierVendor: '',
    weight: '',
    length: '',
    width: '',
    height: '',
    volume: '',
    productImage: '',
    inventoryUOM: '',
    packingType: '',
    thickness: '',
    reorderLevel: '',
    maxQTY: '',
    minQTY: '',
    shape: '',
    itemMasterVarients: [],

    // Additional fields for UPDATE_ITEM_MASTER API compatibility
    sku: '',
    itemCode: '',
    modelNumber: '',
    discountPrice: '',
    priceHistory: '',
    currency: '',
    taxCategory: '',
    stockQuantity: '',
    minStockLevel: '',
    maxStockLevel: '',
    restockDate: '',
    locationWarehouse: '',
    additionalImages: '',
    color: '',
    size: '',
    material: '',
    style: '',
    finish: '',
    supplierName: '',
    manufacturerName: '',
    manufacturerPartNumber: '',
    leadTime: '',
    saleStartDate: '',
    saleEndDate: '',
    promotionCodes: '',
    specialOffers: '',
    shippingWeight: '',
    shippingDimensions: '',
    shippingClass: '',
    shippingMethod: '',
    shippingRestrictions: '',
    ratingReviews: '',
    warrantyInformation: '',
    returnPolicy: '',
    expirationDate: '',
    availabilityStatus: '',
    productTags: '',
    active: true,
    conversitionRate: '',
    itemMasterDetails: [],

    // CreateItem API compatibility fields
    itemNo: '',
    Vat: null,
    PackingUnitMeasurement: null,
    InventoryUom: null,
    Supplier: null,
    PackingType: null,
    Category: null,
    SubCategory: null,
    StockType: null,
    purchasePrice: '',
    salePrice: '',
    minLevel: '',
    maxLevel: '',
    convToInvUOM: '',
    address: '',
    adjustmentAccount: null,
    grnAccount: null,
    cgsAccount: null,
    wastageAccount: null,
    InventoryAccounts: null,
    images: [],
    imageUrl: '',
  });

  // State variables - SAME as your fixed version
  const [suppliers, setSuppliers] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [uomList, setUomList] = useState([]);
  const [variants, setVariants] = useState([]);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [isActive, setIsActive] = useState(true);
  const [loading, setLoading] = useState(false);

  // Additional state variables from CreateItem
  const [subCategoryOptions, setSubCategoryOptions] = useState([]);
  const [unitMeasurement, setunitMeasurement] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [packingUom, setPackingUOMOptions] = useState([]);
  const [packingType, setPackingType] = useState([]);
  const [stockType, setStockType] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [vat, setvat] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [ItemCode, setItemCode] = useState('');
  const [Assests, setAssets] = useState(false);

  useEffect(() => {
    // Fetch all dropdown data using your FIXED APIs
    fetchDropdownData();
    initializeFormData();
  }, [val]);

  // Initialize form data with proper mapping for UPDATE_ITEM_MASTER
  const initializeFormData = () => {
    if (val) {
      setFormData({
        // Main fields
        record_Id: val.record_Id || '',
        itemName: val.itemName || '',
        brand: val.brand || '',
        description: val.description || val.itemName || '',
        retailPrice: val.retailPrice || '',
        wholesalePrice: val.wholesalePrice || '',
        costPrice: val.costPrice || '',
        taxRate: val.taxRate || '',
        category: val.category || '',
        subcategory: val.subcategory || '',
        barcode: val.barcode || '',
        supplierVendor: val.supplierVendor || '',
        weight: val.weight || '',
        length: val.length || '',
        width: val.width || '',
        height: val.height || '',
        volume: val.volume || '',
        productImage: val.productImage || '',
        inventoryUOM: val.inventoryUOM || '',
        packingType: val.packingType || '',
        thickness: val.thickness || '',
        reorderLevel: val.reorderLevel || '',
        maxQTY: val.maxQTY || '',
        minQTY: val.minQTY || '',
        shape: val.shape || '',
        itemMasterVarients: val.itemMasterVarients || [],

        // Additional UPDATE_ITEM_MASTER fields
        sku: val.sku || '',
        itemCode: val.itemCode || '',
        modelNumber: val.modelNumber || '',
        discountPrice: val.discountPrice || '',
        priceHistory: val.priceHistory || '',
        currency: val.currency || Currency?.currency?.name || '',
        taxCategory: val.taxCategory || '',
        stockQuantity: val.stockQuantity || '',
        minStockLevel: val.minStockLevel || '',
        maxStockLevel: val.maxStockLevel || '',
        restockDate: val.restockDate ? moment(val.restockDate).format('YYYY-MM-DD') : '',
        locationWarehouse: val.locationWarehouse || '',
        additionalImages: val.additionalImages || '',
        color: val.color || '',
        size: val.size || '',
        material: val.material || '',
        style: val.style || '',
        finish: val.finish || '',
        supplierName: val.supplierName || '',
        manufacturerName: val.manufacturerName || '',
        manufacturerPartNumber: val.manufacturerPartNumber || '',
        leadTime: val.leadTime ? moment(val.leadTime).format('YYYY-MM-DD') : '',
        saleStartDate: val.saleStartDate ? moment(val.saleStartDate).format('YYYY-MM-DD') : '',
        saleEndDate: val.saleEndDate ? moment(val.saleEndDate).format('YYYY-MM-DD') : '',
        promotionCodes: val.promotionCodes || '',
        specialOffers: val.specialOffers || '',
        shippingWeight: val.shippingWeight || '',
        shippingDimensions: val.shippingDimensions || '',
        shippingClass: val.shippingClass || '',
        shippingMethod: val.shippingMethod || '',
        shippingRestrictions: val.shippingRestrictions || '',
        ratingReviews: val.ratingReviews || '',
        warrantyInformation: val.warrantyInformation || '',
        returnPolicy: val.returnPolicy || '',
        expirationDate: val.expirationDate ? moment(val.expirationDate).format('YYYY-MM-DD') : '',
        availabilityStatus: val.availabilityStatus || '',
        productTags: val.productTags || '',
        active: val.active ?? val.itemStatus ?? true,
        conversitionRate: val.conversitionRate || '',
        itemMasterDetails: val.itemMasterVarients || val.itemMasterDetails || [],

        // CreateItem API compatibility mapping
        itemNo: val.record_Id || '',
        purchasePrice: val.costPrice || '',
        salePrice: val.retailPrice || '',
        minLevel: val.minQTY || '',
        maxLevel: val.maxQTY || '',
        convToInvUOM: val.conversitionRate || '',
        address: '',
        imageUrl: val.productImage || '',
      });
      setIsActive(val.itemStatus ?? val.active ?? true);
      setVariants(val.itemMasterVarients || val.itemMasterDetails || []);
      setItemCode(val.itemCode || '');
    }
  };
  debugger;
  useEffect(() => {
    if (!val || !supplier.length) return;
    const found = supplier.find((s) => s?.supplierName?.trim()?.toLowerCase() === (val?.supplierVendor || val?.supplierName || '').trim().toLowerCase());
    if (found) {
      setFormData((prev) => ({
        ...prev,
        Supplier: { label: found.supplierName, value: found },
        supplierVendor: found.supplierName,
        supplierName: found.supplierName,
      }));
    }
  }, [supplier, val]);
  // Your FIXED fetchDropdownData function - keeping it exactly as you have it
  const fetchDropdownData = async () => {
    try {
      const apiService = new ApiService();
      const apiService2 = new ApiService2();
      let param = `?isActive=true`;
      // Account options
      const accountResponse = await apiService2.get('GET_ACCOUNTS');
      setAccounts(accountResponse.data.result);
      // Fetch vat options
      const vat = await apiService.getApiParamater('GET_TAX', param);
      setvat(vat.data?.result);
      // Fetch inventory UOM options
      const unitMeasurementResponse = await apiService2.getApiParamater('GET_EUNIT_MEASUREMENT', param);
      setunitMeasurement(unitMeasurementResponse?.data?.result);
      const Supplier = await apiService2.getApiParamater('GET_SUPPLIER', param);
      setSupplier(Supplier?.data?.result);
      // Fetch category options
      const categoryResponse = await apiService.getApiParamater('GET_CATEGORY_MASTER', param);
      setCategoryOptions(categoryResponse?.data?.result);
      const subCategoryResponse = await apiService.getApiParamater('GET_SUB_CATEGORY_MASTER', param);
      setSubcategories(subCategoryResponse.data.result);
      // Fetch packing Type
      const packingResponse = await apiService2.getApiParamater('GET_EPACKING', param);
      setPackingType(packingResponse?.data?.result);
      // Fetch stock type options
      const stockType = await apiService2.getApiParamater('GET_STOCK_TYPE', param);
      setStockType(stockType?.data?.result);
      // Fetch packing UOM options
      const packingUOMResponse = await apiService2.getApiParamater('GET_EUNIT_MEASUREMENT', param);
      setPackingUOMOptions(packingUOMResponse?.data?.result);
      // Add more API calls to fetch other dropdown options
    } catch (error) {
      console.error('Error fetching dropdown data:', error);
      // Handle error as needed
    }
  };

  useEffect(() => {
    const item = val;
    if (!item || !vat.length || !unitMeasurement.length || !packingType.length || !categoryOptions.length || !stockType.length) return;

    // VAT
    const selectedVat = vat.find((v) => v.taxPercentage === item?.taxRate);
    // Inv UOM
    const selectedInvUOM = unitMeasurement.find((uom) => uom?.description === item?.inventoryUOM);
    // Packing Type
    const selectedPackingType = packingType.find((pt) => pt?.description === item?.packingType);
    // Category
    const selectedCategory = categoryOptions.find((cat) => cat?.catName === item?.category);
    // Stock Type (Inventory)
    const selectedStocktype = stockType.find((st) => st?.stockTypeName === 'Inventory');

    setFormData((prev) => ({
      ...prev,
      ...(selectedVat && { Vat: { label: `${selectedVat.name} ${selectedVat.taxPercentage} %`, value: selectedVat } }),
      ...(selectedInvUOM && { InventoryUom: { label: selectedInvUOM.description, value: selectedInvUOM } }),
      ...(selectedPackingType && { PackingType: { label: selectedPackingType.description, value: selectedPackingType } }),
      ...(selectedCategory && { Category: { label: selectedCategory.catName, value: selectedCategory } }),
      ...(selectedStocktype && { StockType: { label: selectedStocktype.stockTypeName, value: selectedStocktype } }),
    }));

    // CRITICAL: load subcategories for the selected category in edit mode
    if (selectedCategory?.catCode || selectedCategory?.catName) {
      handleSubcat({ value: selectedCategory });
    }
  }, [vat, unitMeasurement, packingType, categoryOptions, stockType, val]);
  // NEW: hydrate SubCategory once subCategoryOptions are ready
  useEffect(() => {
    if (!val || !subCategoryOptions.length) return;
    const found = subCategoryOptions.find((sc) => sc?.subcatname?.trim()?.toLowerCase() === (val?.subcategory || '').trim().toLowerCase());
    if (found) {
      setFormData((prev) => ({
        ...prev,
        SubCategory: { label: found.subcatname, value: found },
        subcategory: found.subcatname,
      }));
    }
  }, [subCategoryOptions, val]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
      // Sync related fields for both APIs
      ...(name === 'retailPrice' && { salePrice: value }),
      ...(name === 'costPrice' && { purchasePrice: value }),
      ...(name === 'minQTY' && { minLevel: value, minStockLevel: value }),
      ...(name === 'maxQTY' && { maxLevel: value, maxStockLevel: value }),
      ...(name === 'reorderLevel' && { reorderLevel: value }),
      ...(name === 'shape' && { shape: value }),
      ...(name === 'size' && { size: value }),
    });
  };

  const handleSelectChange = (name, selectedOption) => {
    setFormData({ ...formData, [name]: selectedOption?.value || selectedOption?.label || '' });
  };

  // Handle dropdown changes for CreateItem API compatibility
  const handlevatChange = (selectedOption) => {
    setFormData({
      ...formData,
      Vat: selectedOption,
      taxRate: selectedOption?.value?.taxPercentage || '',
    });
  };

  const handleIUtMeasurementChange = (selectedOption) => {
    setFormData({
      ...formData,
      InventoryUom: selectedOption,
      inventoryUOM: selectedOption?.label || '',
    });
  };

  const handlePackingTypeChange = (selectedOption) => {
    setFormData({
      ...formData,
      PackingType: selectedOption,
      packingType: selectedOption?.label || '',
    });
  };

  const handleSupplierChange = (selectedOption) => {
    setFormData({
      ...formData,
      Supplier: selectedOption,
      supplierVendor: selectedOption?.label || '',
      supplierName: selectedOption?.label || '',
    });
  };

  const handleCategoryChange = (selectedOption) => {
    setFormData({
      ...formData,
      Category: selectedOption,
      category: selectedOption?.label || '',
    });
    if (selectedOption?.value?.catCode) {
      handleSubcat(selectedOption);
    }
  };

  const handleSubCategoryChange = (selectedOption) => {
    setFormData({
      ...formData,
      SubCategory: selectedOption,
      subcategory: selectedOption?.label || '',
    });
  };

  const handleStockChange = (selectedOption) => {
    setFormData({ ...formData, StockType: selectedOption });
  };

  // Handle subcategory fetch - keeping your logic
  const handleSubcat = async (selectedOption) => {
    try {
      const apiService = new ApiService();
      let param = `?isActive=true&Catcode=${selectedOption?.value.catCode}`;
      let itemparam = `?Category=${selectedOption?.value.catCode}`;

      debugger;
      const subCategoryResponse = await apiService.getApiParamater('GET_SUB_CATEGORY_MASTER', param);
      // const ItemCodeResponse = await apiService.getApiParamater('GET_ITEM_CODE', itemparam);
      setSubCategoryOptions(subCategoryResponse?.data?.result);
      // setItemCode(ItemCodeResponse.data.result[0]?.itemCode || '');
    } catch (error) {
      console.error('Error:', error);
      toast.error('Failed to fetch subcategories');
    }
  };

  const handleVariantChange = (index, field, value) => {
    const updatedVariants = [...variants];
    updatedVariants[index] = { ...updatedVariants[index], [field]: value };
    setVariants(updatedVariants);
    setFormData({
      ...formData,
      itemMasterVarients: updatedVariants,
      itemMasterDetails: updatedVariants,
    });
  };

  const handleAddVariant = () => {
    const newVariant = {
      itemNo: '',
      itemDescription: '',
      purchasePrice: 0,
      salePrice: 0,
      stock: 0,
      rol: 0,
      minLevel: 0,
      maxLevel: 0,
      purchaseUnit: 0,
      saleUnit: 0,
      brand: formData.brand,
      supplier: formData.supplierVendor,
      remarks1: '',
      remarks2: '',
      warranty: '',
      vat: '0.00',
      cst: '',
      st: '',
      stockType: '',
      category: formData.category,
      subCategory: formData.subcategory,
      warehouseLocation: '',
      binLocation: '',
      unitMeasurement: formData.inventoryUOM,
      baseUnit: '',
      packingType: formData.packingType,
      size: formData.size,
      shape: formData.shape,
      weight: formData.weight?.toString() || '',
      finish: formData.finish,
      barcode: formData.barcode,
      oemCode: '',
      hsCode: '',
      shippingType: formData.shippingMethod,
      manufacturer: formData.manufacturerName,
      inventory: '',
      fixedAsset: '',
      sales: '',
      purchased: '',
      lastPriceUpdated: new Date().toISOString(),
      acCode: '',
      acName: '',
      sgCode: '',
      exp1: '',
      exp2: '',
      exp3: '',
      exp4: '',
      exp5: '',
      exp6: '',
      exp7: '',
      exp8: '',
      exp9: '',
      exp10: '',
      modifiedBy: UserId?.toString() || '',
      modifiedOn: new Date().toISOString(),
      createdBy: UserId?.toString() || '',
      createdOn: new Date().toISOString(),
      primaryUOM: formData.inventoryUOM,
      convToInvUOM: 0,
      convToPriUOM: 0,
      length: formData.length?.toString() || '',
      width: formData.width?.toString() || '',
      height: formData.height?.toString() || '',
      volume: formData.volume?.toString() || '',
      thickness: formData.thickness?.toString() || '',
    };
    const updatedVariants = [...variants, newVariant];
    setVariants(updatedVariants);
    setFormData({
      ...formData,
      itemMasterVarients: updatedVariants,
      itemMasterDetails: updatedVariants,
    });
  };

  const handleDeleteVariant = (index) => {
    const updatedVariants = variants.filter((_, i) => i !== index);
    setVariants(updatedVariants);
    setFormData({
      ...formData,
      itemMasterVarients: updatedVariants,
      itemMasterDetails: updatedVariants,
    });
  };

  const handleSwitchChange = () => {
    setIsActive(!isActive);
  };

  // Image upload handling
  const UploadImage = async () => {
    if (!formData?.images && !formData?.imageUrl && !formData?.productImage) {
      return formData?.productImage || formData?.imageUrl || '';
    } else if (formData?.images && formData?.images?.length > 0) {
      try {
        const apiService = new ApiService();
        const formdata = new FormData();
        for (const image of formData?.images) {
          if (image.file) {
            formdata.append('Images', image?.file);
          }
        }
        const response = await apiService.postMultiPart('UPLOAD_IMG', formdata);

        if (response?.data?.statusCode === 201) {
          return response?.data?.result;
        } else {
          toast.error(response?.data?.msg);
          return formData?.productImage || formData?.imageUrl || '';
        }
      } catch (error) {
        toast.error('Something went wrong with the image. Please try again!');
        return formData?.productImage || formData?.imageUrl || '';
      }
    } else {
      return formData?.productImage || formData?.imageUrl || '';
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const imageUrl = await UploadImage();

      if (formData.record_Id) {
        // Update existing item using UPDATE_ITEM_MASTER API with EXACT body structure
        const body = {
          record_Id: parseInt(formData.record_Id) || 0,
          sku: formData.sku || '',
          itemCode: formData.itemCode || '',
          itemName: formData.itemName || '',
          description: formData.description || '',
          brand: formData.brand || '',
          modelNumber: formData.modelNumber || '',
          barcode: formData.barcode || '',
          retailPrice: parseFloat(formData.retailPrice) || 0,
          wholesalePrice: parseFloat(formData.wholesalePrice) || 0,
          costPrice: parseFloat(formData.costPrice) || 0,
          discountPrice: parseFloat(formData.discountPrice) || 0,
          priceHistory: formData.priceHistory || '',
          currency: formData.currency || Currency?.currency?.name || '',
          taxRate: parseFloat(formData.taxRate) || 0,
          taxCategory: formData.taxCategory || '',
          stockQuantity: formData.stockQuantity || '',
          minStockLevel: parseInt(formData.minStockLevel) || parseInt(formData.minQTY) || 0,
          maxStockLevel: parseInt(formData.maxStockLevel) || parseInt(formData.maxQTY) || 0,
          restockDate: formData.restockDate ? new Date(formData.restockDate).toISOString() : null,
          supplierVendor: formData.supplierVendor || '',
          locationWarehouse: formData.locationWarehouse || '',
          weight: parseFloat(formData.weight) || 0,
          length: parseFloat(formData.length) || 0,
          width: parseFloat(formData.width) || 0,
          height: parseFloat(formData.height) || 0,
          volume: parseFloat(formData.volume) || 0,
          productImage: imageUrl || '',
          additionalImages: formData.additionalImages || '',
          color: formData.color || '',
          size: formData.size || '',
          material: formData.material || '',
          style: formData.style || '',
          finish: formData.finish || '',
          supplierName: formData.supplierName || '',
          manufacturerName: formData.manufacturerName || '',
          manufacturerPartNumber: formData.manufacturerPartNumber || '',
          leadTime: formData.leadTime ? new Date(formData.leadTime).toISOString() : null,
          saleStartDate: formData.saleStartDate ? new Date(formData.saleStartDate).toISOString() : null,
          saleEndDate: formData.saleEndDate ? new Date(formData.saleEndDate).toISOString() : null,
          promotionCodes: formData.promotionCodes || '',
          specialOffers: formData.specialOffers || '',
          shippingWeight: parseFloat(formData.shippingWeight) || 0,
          shippingDimensions: formData.shippingDimensions || '',
          shippingClass: formData.shippingClass || '',
          shippingMethod: formData.shippingMethod || '',
          shippingRestrictions: formData.shippingRestrictions || '',
          ratingReviews: formData.ratingReviews || '',
          warrantyInformation: formData.warrantyInformation || '',
          returnPolicy: formData.returnPolicy || '',
          expirationDate: formData.expirationDate ? new Date(formData.expirationDate).toISOString() : null,
          availabilityStatus: formData.availabilityStatus || '',
          itemStatus: isActive,
          category: formData.category || '',
          subcategory: formData.subcategory || '',
          productTags: formData.productTags || '',
          inventoryUOM: formData.inventoryUOM || '',
          packingType: formData.packingType || '',
          thickness: parseFloat(formData.thickness) || 0,
          reorderLevel: parseInt(formData.reorderLevel) || 0,
          maxQTY: parseInt(formData.maxQTY) || 0,
          minQTY: parseInt(formData.minQTY) || 0,
          shape: formData.shape || '',
          active: isActive,
          conversitionRate: parseFloat(formData.conversitionRate) || 0,
          itemMasterDetails: variants.map((variant) => ({
            ...variant,
            modifiedBy: UserId?.toString() || '',
            modifiedOn: new Date().toISOString(),
            createdBy: variant.createdBy || UserId?.toString() || '',
            createdOn: variant.createdOn || new Date().toISOString(),
          })),
        };

        const apiService = new ApiService();
        let response = await apiService.put('UPDATE_ITEM_MASTER', body);

        if (response.data.statusCode === 200 || response.data.statusCode === 201) {
          toast.success('Item updated successfully');
          navigate('/admin/menu');
        } else {
          toast.warning(response?.data?.message || 'Update failed');
        }
      } else {
        // Create new item using CreateItem CREATE_ITEM API (keeping your original logic)
        const body = {
          itemNo: ItemCode || formData.itemName,
          itemDescription: formData?.description || formData?.itemName,
          purchasePrice: parseInt(formData?.costPrice || formData?.purchasePrice || 0),
          salePrice: parseInt(formData?.retailPrice || formData?.salePrice || 0),
          minLevel: parseInt(formData?.minQTY || formData?.minLevel || 0),
          maxLevel: parseInt(formData?.maxQTY || formData?.maxLevel || 0),
          supplier: formData?.Supplier?.value?.record_Id?.toString() || '',
          vat: formData.Vat?.value?.name || '',
          category: formData?.Category?.value?.catCode?.toString() || '',
          subCategory: formData.SubCategory?.value?.subcatcode?.toString() || '',
          stockType: formData.StockType?.value?.stockTypeCode?.toString() || '1',
          unitMeasurement: formData?.InventoryUom?.label || formData?.inventoryUOM,
          packingType: formData?.PackingType?.label || formData?.packingType,
          primaryUOM: '0',
          size: formData?.size || '',
          shape: formData?.shape || '',
          weight: formData?.weight || '',
          fixedAsset: Assests,
          inventory: 'True',
          sales: 'False',
          loggedInUser: UserId,
          width: formData?.width || '',
          thickness: formData?.thickness || '',
          height: formData?.height || '',
          length: formData?.length || '',
          volume: formData?.volume || '',
          reorderLevel: formData?.reorderLevel || '0',
          convToInvUOM: formData?.convToInvUOM || 1,
          convToPriUOM: 0,
          remarks2: '0',
          warehouseLocation: '0',
          binLocation: '0',
          finish: 'False',
          purchased: 'False',
          inventoryAcCode: formData.InventoryAccounts?.value?.accountCode || '',
          inventoryAcName: formData.InventoryAccounts?.label || '',
          grnAcCode: formData.grnAccount?.value?.accountCode || '',
          grnAcName: formData.grnAccount?.label || '',
          invoiceAcName: '0',
          invoiceAcCode: '0',
          cgsAcCode: formData.cgsAccount?.value?.accountCode || '',
          cgsAcName: formData.cgsAccount?.label || '',
          adjAcCode: formData.adjustmentAccount?.value?.accountCode || '',
          adjAcName: formData.adjustmentAccount?.label || '',
          wastageAccountCode: formData.wastageAccount?.value?.accountCode || '',
          wastageAccountName: formData.wastageAccount?.label || '',
          workInProgressAccountCode: '0',
          workInProgressAccountName: '0',
          issueAccountCode: '0',
          issueAccountName: '0',
          consumables: '0',
          food: '0',
          packingUOM: formData.PackingUnitMeasurement?.label || formData?.inventoryUOM,
          exp9: '1',
        };

        const apiService = new ApiService();
        let response = await apiService.post('CREATE_ITEM', body);

        if (response.data.statusCode === 201) {
          toast.success('Item created successfully');
          navigate('admin/menu');
        } else {
          toast.warning(response?.data?.message || 'Creation failed');
        }
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error('Something went wrong. Please try again!');
    } finally {
      setLoading(false);
    }
  };

  const handleImagesSelect = (images) => {
    setFormData({ ...formData, images: images, productImage: images[0]?.url || '' });
  };

  const handleImageRemove = () => {
    setFormData({ ...formData, productImage: '', images: [] });
  };

  return (
    <div className="p-5">
      <div className="p-5">
        <div className="row rows">
          <div className="col-lg-6 col6 creatBox">
            <div className="headtext">Basic Information</div>
            <div className="orngbox">
              <div className="">
                <label htmlFor="itemName" className="form-label texthead">
                  Item Name *
                </label>
                <input type="text" className="p-2 form-control" id="itemName" name="itemName" value={formData.itemName} onChange={handleInputChange} required />
              </div>

              <div className="py-3">
                <label htmlFor="brand" className="form-label texthead">
                  Brand *
                </label>
                <input type="text" className="p-2 form-control" id="brand" name="brand" value={formData.brand} onChange={handleInputChange} required />
              </div>

              <div className="">
                <label htmlFor="category" className="form-label texthead">
                  Category *
                </label>
                <Select
                  value={formData.Category}
                  onChange={(option) => handleCategoryChange(option)}
                  options={categoryOptions?.map((cat) => ({ value: cat, label: cat.catName }))}
                  placeholder="Select Category"
                />
              </div>

              <div className="py-3">
                <label htmlFor="subcategory" className="form-label texthead">
                  Subcategory *
                </label>
                <Select
                  value={formData.SubCategory}
                  onChange={(option) => handleSubCategoryChange(option)}
                  options={subCategoryOptions.map((sub) => ({ value: sub, label: sub.subcatname }))}
                  placeholder="Select Subcategory"
                />
              </div>

              <div className="">
                <label htmlFor="supplierVendor" className="form-label texthead">
                  Supplier *
                </label>
                <Select
                  value={formData.Supplier}
                  onChange={(option) => handleSupplierChange(option)}
                  options={supplier?.map((sup) => ({ value: sup, label: sup?.supplierName }))}
                  placeholder="Select Supplier"
                />
              </div>

              <div className="py-3">
                <label htmlFor="barcode" className="form-label texthead">
                  Barcode
                </label>
                <input type="text" className="p-2 form-control" id="barcode" name="barcode" value={formData.barcode} onChange={handleInputChange} />
              </div>

              <div className="">
                <label htmlFor="description" className="form-label texthead">
                  Description *
                </label>
                <textarea
                  className="p-2 form-control"
                  id="description"
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                  rows="3"
                  required
                />
              </div>

              <div className="py-3">
                <label htmlFor="taxRate" className="form-label texthead">
                  VAT *
                </label>
                <Select
                  value={formData.Vat}
                  onChange={(option) => handlevatChange(option)}
                  options={vat.map((vatItem) => ({ value: vatItem, label: `${vatItem?.name} ${vatItem?.taxPercentage} %` }))}
                  placeholder="Select VAT"
                />
              </div>

              <div className="py-3 d-flex justify-content-between">
                <div className="d-flex text-center">
                  <div className="headtes p-2">{isActive ? 'Active' : 'Inactive'}</div>
                  <div className="form-check form-switch">
                    <input className="form-check-input" type="checkbox" checked={isActive} onChange={handleSwitchChange} />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6 col6">
            <div className="creatBox">
              <div className="headtext">Upload Item Picture</div>
              <div>
                <ImageUpload onImagesSelect={handleImagesSelect} onImageRemove={handleImageRemove} formData={formData} />
              </div>
            </div>

            <div className="mt-4">
              <div className="headtext">Physical Properties</div>
              <div className="creatBox">
                <div className="row">
                  <div className="col-md-6">
                    <label htmlFor="weight" className="form-label texthead">
                      Weight
                    </label>
                    <input type="number" className="form-control" id="weight" name="weight" value={formData.weight} onChange={handleInputChange} />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="volume" className="form-label texthead">
                      Volume
                    </label>
                    <input type="number" className="form-control" id="volume" name="volume" value={formData.volume} onChange={handleInputChange} />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-md-4">
                    <label htmlFor="length" className="form-label texthead">
                      Length
                    </label>
                    <input type="number" className="form-control" id="length" name="length" value={formData.length} onChange={handleInputChange} />
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="width" className="form-label texthead">
                      Width
                    </label>
                    <input type="number" className="form-control" id="width" name="width" value={formData.width} onChange={handleInputChange} />
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="height" className="form-label texthead">
                      Height
                    </label>
                    <input type="number" className="form-control" id="height" name="height" value={formData.height} onChange={handleInputChange} />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-md-6">
                    <label htmlFor="thickness" className="form-label texthead">
                      Thickness
                    </label>
                    <input type="number" className="form-control" id="thickness" name="thickness" value={formData.thickness} onChange={handleInputChange} />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="shape" className="form-label texthead">
                      Shape
                    </label>
                    <input type="text" className="form-control" id="shape" name="shape" value={formData.shape} onChange={handleInputChange} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row rows pt-5">
          <div className="col-lg-6 col6 creatBox">
            <div className="headtext">Pricing Information</div>
            <div className="orngbox">
              <div className="">
                <label htmlFor="retailPrice" className="form-label texthead">
                  Retail Price *
                </label>
                <input
                  type="number"
                  className="p-2 form-control"
                  id="retailPrice"
                  name="retailPrice"
                  value={formData.retailPrice}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="py-3">
                <label htmlFor="wholesalePrice" className="form-label texthead">
                  Wholesale Price *
                </label>
                <input
                  type="number"
                  className="p-2 form-control"
                  id="wholesalePrice"
                  name="wholesalePrice"
                  value={formData.wholesalePrice}
                  onChange={handleInputChange}
                  required
                />
              </div>

              {/* <div className="">
                <label htmlFor="costPrice" className="form-label texthead">
                  Cost Price *
                </label>
                <input
                  type="number"
                  className="p-2 form-control"
                  id="costPrice"
                  name="costPrice"
                  value={formData.costPrice}
                  onChange={handleInputChange}
                  required
                />
              </div> */}

              <div className="py-3">
                <label htmlFor="taxRate" className="form-label texthead">
                  Tax Rate (%) *
                </label>
                <input
                  type="number"
                  className="p-2 form-control"
                  id="taxRate"
                  name="taxRate"
                  value={formData.taxRate}
                  onChange={handleInputChange}
                  disabled
                  required
                />
              </div>
            </div>
          </div>

          <div className="col-lg-6 col6">
            <div className="creatBox">
              <div className="headtext">Inventory Information</div>
              <div className="orngbox">
                <div className="">
                  <label htmlFor="inventoryUOM" className="form-label texthead">
                    Inventory UOM *
                  </label>
                  <Select
                    value={formData.InventoryUom}
                    onChange={(option) => handleIUtMeasurementChange(option)}
                    options={unitMeasurement.map((uom) => ({ value: uom, label: uom.description }))}
                    placeholder="Select UOM"
                  />
                </div>

                <div className="py-3">
                  <label htmlFor="packingType" className="form-label texthead">
                    Packing Type
                  </label>
                  <Select
                    value={formData.PackingType}
                    onChange={(option) => handlePackingTypeChange(option)}
                    options={packingType.map((packing) => ({ value: packing, label: packing.description }))}
                    placeholder="Select Packing Type"
                  />
                </div>

                <div className="row">
                  <div className="col-md-4">
                    <label htmlFor="minQTY" className="form-label texthead">
                      Min QTY
                    </label>
                    <input type="number" className="form-control" id="minQTY" name="minQTY" value={formData.minQTY} onChange={handleInputChange} />
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="maxQTY" className="form-label texthead">
                      Max QTY
                    </label>
                    <input type="number" className="form-control" id="maxQTY" name="maxQTY" value={formData.maxQTY} onChange={handleInputChange} />
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="reorderLevel" className="form-label texthead">
                      Reorder Level
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      id="reorderLevel"
                      name="reorderLevel"
                      value={formData.reorderLevel}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-md-6">
                    <label htmlFor="convToInvUOM" className="form-label texthead">
                      Conversion Rate
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      id="convToInvUOM"
                      name="convToInvUOM"
                      value={formData.convToInvUOM}
                      onChange={handleInputChange}
                      placeholder="1"
                    />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="size" className="form-label texthead">
                      Size
                    </label>
                    <input type="text" className="form-control" id="size" name="size" value={formData.size} onChange={handleInputChange} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row rows pt-5">
          <div className="col-lg-12">
            <div className="creatBox">
              <div className="headtext">Product Variants</div>
              <div className="orngbox">
                <button type="button" className="btn btn-primary mb-3" onClick={handleAddVariant}>
                  Add Variant
                </button>

                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Item No</th>
                        <th>Description</th>
                        <th>Purchase Price</th>
                        <th>Sale Price</th>
                        <th>Stock</th>
                        <th>VAT</th>
                        <th>Warehouse Location</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {variants.map((variant, index) => (
                        <tr key={index}>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              value={variant.itemNo || ''}
                              onChange={(e) => handleVariantChange(index, 'itemNo', e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              value={variant.itemDescription || ''}
                              onChange={(e) => handleVariantChange(index, 'itemDescription', e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              className="form-control"
                              value={variant.purchasePrice || ''}
                              onChange={(e) => handleVariantChange(index, 'purchasePrice', parseFloat(e.target.value) || 0)}
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              className="form-control"
                              value={variant.salePrice || ''}
                              onChange={(e) => handleVariantChange(index, 'salePrice', parseFloat(e.target.value) || 0)}
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              className="form-control"
                              value={variant.stock || ''}
                              onChange={(e) => handleVariantChange(index, 'stock', parseInt(e.target.value) || 0)}
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              value={variant.vat || ''}
                              onChange={(e) => handleVariantChange(index, 'vat', e.target.value)}
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              value={variant.warehouseLocation || ''}
                              onChange={(e) => handleVariantChange(index, 'warehouseLocation', e.target.value)}
                            />
                          </td>
                          <td>
                            <button type="button" className="btn btn-danger btn-sm" onClick={() => handleDeleteVariant(index)}>
                              <Delete />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="end pt-4">
          <button className="addItem-btn" type="submit" onClick={handleSubmit} disabled={loading}>
            {loading ? 'Processing...' : formData.record_Id ? 'Update' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
};

const mapStatetoProps = (state) => state;
export default connect(mapStatetoProps)(UpdateMenu);
